const order = [
    {
        path: '/order',
        name: 'order',
        component: () => import('@/view/order/Index'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/pay/:id',
        name: 'pay',
        component: () => import('@/view/order/Pay'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/order/pay/success',
        name: 'paySuccess',
        component: () => import('@/view/order/Success'),
        meta: {
            requireAuth: true
        }
    }
]
export default order